import { apiRequest } from '../../apiCall'


export const getAllusers = (params,status) => apiRequest('Auth.GetUsers',{...params}, `${status?"?domainStatus="+status:''}` )
export const getUsrInfo = (params) => apiRequest('Auth.GetUserDetails',{},`/${params}`)